var map = {
	"./1.png": 2875,
	"./10.png": 2876,
	"./11.png": 2877,
	"./12.png": 2878,
	"./13.png": 2879,
	"./14.png": 2880,
	"./15.png": 2881,
	"./16.png": 2882,
	"./17.png": 2883,
	"./18.png": 2884,
	"./19.png": 2885,
	"./2.png": 2886,
	"./20.png": 2887,
	"./21.png": 2888,
	"./22.png": 2889,
	"./23.png": 2890,
	"./24.png": 2891,
	"./25-1.png": 2892,
	"./25-2.png": 2893,
	"./26.png": 2894,
	"./27.png": 2895,
	"./3.png": 2896,
	"./30.png": 2897,
	"./31.png": 2898,
	"./32.png": 2899,
	"./33.png": 2900,
	"./35.png": 2901,
	"./36.png": 2902,
	"./37.png": 2903,
	"./38.png": 2904,
	"./39.png": 2905,
	"./4.png": 2906,
	"./40.png": 2907,
	"./46.png": 2908,
	"./47.png": 2909,
	"./5.png": 2910,
	"./6.png": 2911,
	"./7.png": 2912,
	"./8.png": 2913,
	"./9.png": 2914
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3500;


//////////////////
// WEBPACK FOOTER
// ./src/routes/visualChart/components/Stage/images ^\.\/.*\.png$
// module id = 3500
// module chunks = 1